export default __webpack_public_path__ + "8786b59e766cf90fb64fc4093fd2b4f5.png";